import React from 'react'
import './Home.css'

const Home = () => (
  <div>
    <h1>Hi, I am the Home Screen</h1>
  </div>
)

export default Home
